// extracted by mini-css-extract-plugin
export default {"title":"Title--title--jxm95"};